module.exports = __webpack_public_path__ + "static/img/053 3.c7de6e5e.jpg";